import { DateTime } from 'luxon';

export interface IEventRange {
  startDate: DateTime;
  endDate: DateTime;
}

export interface IOccurrenceCollision {
  rangeToCheck: IEventRange;
  collision: IEventRange;
}

export default function checkEpisodeOverlap(
  rangeToCheck: IEventRange,
  events: IEventRange[]
): IOccurrenceCollision | null {
  for (const event of events) {
    const eventEndSeconds = event.endDate?.toSeconds() ?? Infinity;
    const rangeStartSeconds = rangeToCheck.startDate.toSeconds();
    const rangeEndSeconds = rangeToCheck.endDate?.toSeconds() ?? Infinity;

    if (
      (rangeStartSeconds <= eventEndSeconds &&
        rangeEndSeconds >= event.startDate.toSeconds()) ||
      (event.startDate.toSeconds() <= rangeEndSeconds &&
        eventEndSeconds >= rangeStartSeconds)
    ) {
      /*
      return {
        message: `Overlap found: The range from ${quickDateTimeFormat(
          rangeToCheck.startDate
        )} to ${
          rangeToCheck.endDate
            ? quickDateTimeFormat(rangeToCheck.endDate)
            : 'indefinite'
        } overlaps with an episode running from ${quickDateTimeFormat(
          event.startDate
        )} to ${
          event.endDate ? quickDateTimeFormat(event.endDate) : 'indefinite'
        }.`
      };
      */
      return {
        rangeToCheck,
        collision: event
      };
    }
  }
  return null;
}
